<template>
  <div class="not-found text-center">
    Not found :(
  </div>
</template>

<script>
export default {
  name: 'NotFound',
}
</script>

<style lang="scss" scoped>
.not-found {
  height: 80vh;
  padding-top: 20vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/NotFound.vue